export default __webpack_public_path__ + "static/about-12-0722067e4cc968f43bc224ceb1cb9a26.jpeg";